module.exports = __webpack_public_path__ + "img/exercise-2.17f4b0bb.png";